export default __webpack_public_path__ + "static/media/export-icon.449aaaf3.svg";